// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0b4f9a9f","453":"1de48f81"}[chunkId] + ".chunk.js";
};